import React, { useCallback, useState } from 'react'
import { NiceChat } from '@rededor/nice-chat-component-lib-react'
import { useUserStore } from '@/store/useUserStore'

import { appSettings } from '@/shared/consts/appSettings'
import { useIsActiveBreakPoint } from '@/hooks/useIsActiveBreakPoint'
import { isWebView } from '@/utils/helpers/webViewHelper'

import { ChatButton } from '../ChatButton'

type ChatStatus = 'idle' | 'loading' | 'loaded'

export const Chat = () => {
  const isMobile = useIsActiveBreakPoint('medium')
  const [chatStatus, setChatStatus] = useState<ChatStatus>('idle')
  const user = useUserStore((state) => state.user)

  const handleChatStatusChange = useCallback((e: CustomEvent<ChatStatus>) => {
    setChatStatus(e.detail)
  }, [])

  const handleChatClickCapture = useCallback(
    (e: React.MouseEvent) => {
      if (chatStatus === 'loading') {
        e.preventDefault()
        e.stopPropagation()
      }
    },
    [chatStatus]
  )

  if (isWebView()) return null

  return (
    <div
      onClickCapture={handleChatClickCapture}
      style={{ display: 'inline-block' }}
    >
      <NiceChat
        onChatStatusChange={handleChatStatusChange}
        userName={user?.name || ''}
        hasFirstAutomatedMessageContent="Olá"
        isSendFirstMessageAutomatically
        style={{ width: '100%' }}
        isMobile={isMobile}
        token={appSettings.niceChatToken}
      >
        <ChatButton isMobile={isMobile} isOpening={chatStatus === 'loading'} />
      </NiceChat>
    </div>
  )
}
